// handle contact form events
document.addEventListener('DOMContentLoaded', function () {
  const $contactForm = document.querySelector('#contactForm');
  const FEED_BACK_MESSAGE_MODAL = 'feedback-message';

  $contactForm.addEventListener('submit', async (e) => {
    // prevent default submit
    e.preventDefault();

    // check form required fields
    if (!$contactForm.checkValidity()) {
      $contactForm.reportValidity();
      return;
    }
    // get form data
    const formData = new FormData($contactForm);
    const email = formData.get('contact[email]');
    const emailValid = xUtils.validateEmail(email);

    if (!emailValid.isValid) {
      publish(PUB_SUB_EVENTS.xModalOpen, {
        modalName: FEED_BACK_MESSAGE_MODAL,
        contentRender: ($slot) => {
          const $content = $slot.querySelector('.x-footer-modal__feedback-layer');
          const $cancel = $slot.querySelector('.x-footer-modal__operation-cancel');

          $content.innerHTML = `
            <div class="x-footer-modal__feedback-content">
              <p class="x-footer-modal__feedback-text">${emailValid.message}</p>
            </div>
          `;
          if (!$cancel.classList.contains('hidden')) {
            $cancel.classList.add('hidden');
          }
        },
      });
      return;
    }
    const payload = {
      email,
      name: `${formData.get('contact[firstName]')} ${formData.get('contact[lastName]')}`,
      message: formData.get('contact[notes]'),
      target: formData.get('contact[reason]'),
      country: formData.get('contact[country]'),
      source: 'contact-us',
    };

    xUtils.showLoading();
    fetch('https://contact.xds.co/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      timeout: 30000,
    })
      .then((res) => res.json())
      .then((res) => {
        const messageDisplay =
          res.status === 'success'
            ? 'Thanks for reaching out! We’ve got your message and will be in touch soon.'
            : res.error || 'Something went wrong, please try again later.';
        publish(PUB_SUB_EVENTS.xModalOpen, {
          modalName: FEED_BACK_MESSAGE_MODAL,
          contentRender: ($slot) => {
            const $content = $slot.querySelector('.x-footer-modal__feedback-layer');
            const $cancel = $slot.querySelector('.x-footer-modal__operation-cancel');

            $content.innerHTML = `
                <div class="x-footer-modal__feedback-content">
                  <p class="x-footer-modal__feedback-text">${messageDisplay}</p>
                </div>
              `;
            if (!$cancel.classList.contains('hidden')) {
              $cancel.classList.add('hidden');
            }
          },
        });
        $contactForm.reset();
      })
      .catch((err) => {
        console.error(err);
        publish(PUB_SUB_EVENTS.xModalOpen, {
          modalName: FEED_BACK_MESSAGE_MODAL,
          contentRender: ($slot) => {
            const $content = $slot.querySelector('.x-footer-modal__feedback-layer');
            const $cancel = $slot.querySelector('.x-footer-modal__operation-cancel');

            $content.innerHTML = `
              <div class="x-footer-modal__feedback-content">
                <p class="x-footer-modal__feedback-text">Something went wrong, please try again later.</p>
              </div>
            `;
            if (!$cancel.classList.contains('hidden')) {
              $cancel.classList.add('hidden');
            }
          },
        });
      })
      .finally(() => {
        xUtils.hideLoading();
      });
    subscribe(PUB_SUB_EVENTS.xModalConfirm, (params) => {
      if (params.modalName === FEED_BACK_MESSAGE_MODAL) {
        params.closeMethod && params.closeMethod();
      }
    });
  });
});
